module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl border-box h-95p",
    style: ('width:' + _vm.width)
  }, [_c('div', {
    staticClass: "bor-deep-gra bg-wh h-100p ovf-auto"
  }, [_c('p', {
    staticClass: "c-deep-blue p-t-20 p-b-20 p-l-10 p-r-10 m-t-0 m-b-0 bor-b-gray fw-b"
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input),
      expression: "input"
    }],
    attrs: {
      "placeholder": "请输入控件名"
    },
    domProps: {
      "value": (_vm.input)
    },
    on: {
      "change": _vm.change,
      "input": function($event) {
        _vm.input = $event
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "select-list"
  }, _vm._l((_vm.tabInputsTemp), function(item, index) {
    return _c('div', {
      staticClass: "p-t-20 p-b-20 no-select drag p-l-30",
      on: {
        "mousedown": function($event) {
          _vm.dragDown(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fz-24 c-blue no-select m-r-10",
      class: item.icon
    }), _vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  }))]), _vm._v(" "), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curType.name && _vm.dragShow),
      expression: "curType.name && dragShow"
    }],
    staticClass: "temp-drag",
    style: (_vm.dragStyle)
  }, [_c('i', {
    staticClass: "fa fz-24 c-blue no-select m-r-10",
    class: _vm.curType.icon
  }), _vm._v("\n    " + _vm._s(_vm.curType.name) + "\n  ")]), _vm._v(" ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-548a2b0b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/inputType.vue
// module id = 1867
// module chunks = 2